import React from 'react';
import { Tooltip } from 'antd';

const GlobalTooltip = ({ title, children, placement = "top", className = "" }) => {
    if (!title) return children;

    const safeTitle = typeof title === 'object' && title !== null && !React.isValidElement(title)
        ? (title.name || JSON.stringify(title))
        : title;

    return (
        <Tooltip
            title={safeTitle}
            placement={placement}
            overlayClassName={`pcu-tooltip ${className}`}
        >
            {children}
        </Tooltip>
    );
};

export default GlobalTooltip;
